import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { EntityReferenceBasic, EntityStyle, TagLabel } from '@/shared/types';

import type { GlossaryTermDetail } from './glossaryTermDetailApi';

type CreateGlossaryTermRequest = {
  glossary: string;
  parent?: string;
  name: string;
  displayName?: string;
  description?: string;
  tags?: TagLabel[];
  owners?: EntityReferenceBasic[];
  reviewers?: EntityReferenceBasic[];
  synonyms?: string[];
  relatedTerms?: string[];
  mutuallyExclusive?: boolean;
  style?: EntityStyle;
};

export const createGlossaryTermApi = async (request: CreateGlossaryTermRequest): Promise<GlossaryTermDetail> => {
  const { data } = await openMetadataApiClient.put<GlossaryTermDetail>('/glossaryTerms', request);
  return data;
};

export type { CreateGlossaryTermRequest };
export type { EntityReferenceBasic as GlossaryTermEntityReference } from '@/shared/types';
